const state = {
    data : window.APPDATA.translations,
    keys : [],
    keys_fetched : Object.keys(window.APPDATA.translations),
    fetching: false,
    keys_fetching : { },
}

const mutations = {
    APPEND(state, translations) {
        if(!_.isEmpty(translations)) { state.data = _.merge(state.data, translations); }
    },
    KEY_APPEND(state, key) {
        if(Array.isArray(key)) { state.keys = state.keys.concat(key); }
        else { state.keys.push(key); }
        state.keys = _.uniq(state.keys);
    },
    KEYS_CLEANUP(state, keys) {
        state.keys = _.reject(state.keys, (k) => {
            return keys.includes(k);
        });
    },
    KEYS_CLEAR(state, key) {
        state.keys = [];
    },
    KEY_FETCHED(state, key) {
        if(Array.isArray(key)) { state.keys_fetched = state.keys_fetched.concat(key); }
        else { state.keys_fetched.push(key); }
        state.keys_fetched = _.uniq(state.keys_fetched);
    },
    KEY_FETCHING_ADD(state, key) {
        _.each(Array.isArray(key) ? key : [key], (k) => { state.keys_fetching[k] = true; });
    },
    KEY_FETCHING_REMOVE(state, key) {
        _.each(Array.isArray(key) ? key : [key], (k) => { state.keys_fetching[k] = false; });
    },
}

const actions = {
    keyAdd(state, key) {
        state.commit('KEY_APPEND', key);
    },
    keysClear(state, key) {
        state.commit('KEYS_CLEAR', key);
    },
    keysGet({ commit, state }) {
        let keys = [...state.keys];

        if(keys.length > 0) {
            commit('KEYS_CLEAR', keys);

            keys = _.reject(keys, (k) => {
                return state.keys_fetched.includes(k) || _.get(state.keys_fetching, k.replaceAll('/', '_').replaceAll('.', '__'), false);
            });

            commit('KEY_FETCHING_ADD', keys);
        }

        if(keys.length == 0) {
            return new Promise((resolve, reject) => {
                resolve();
            });
        }

        return this._vm.$http.post(this.getters.urls.api.translations, { keys : keys }).then((response) => {

            if(response.data.status) {
                commit('APPEND', response.data.data.translations);
                commit('KEY_FETCHED', keys);
                commit('KEY_FETCHING_REMOVE', keys);
            }


            return response;
        });
    },
}

const getters = {
    data(state) {
        return state.data;
    },
    keys(state) {
        return state.keys;
    },
    keysFetched(state) {
        return state.keys_fetched;
    },
    fetching(state) {
        return state.fetching;
    },
    keysFetching(state) {
        return state.keys_fetching;
    },
    keysIsFetched: (state) => (keys) => {
        let isFetched = true;

        if(!_.isEmpty(keys)) {
            _.each((Array.isArray(keys)?keys:[keys]), (k) => {
                if(!state.keys_fetched.includes(k)) {
                    isFetched = false;
                    return true;
                }
            });
        }

        return isFetched;
    },
}

export default {
    state,
    actions,
    mutations,
    getters,
}